<template>
  <article class="pl-chat-user-list__area">
    <h4 class="pl-chat-user-list__users-list-subtitle">Найдите и добавьте собеседников в чат</h4>

    <div class="pl-chat-user-list__search">
      <v-text-field
        v-model="searchStr"
        :loading="loading"
        class="pl-chat-user-list__search-string"
        label="Поиск пользователей"
        clearable
        @keyup.enter="searchUser()"
        @change="searchUser()"
        @input="handlerEventInput(searchStr)"
        @click:clear="clearSearchString()"
      />
    </div>

    <div v-if="!items.length" v-show="loading" class="pl-chat__messages pl-chat__messages--chat-list-empty">
      {{ emptyMessage }}
    </div>

    <ul class="pl-chat-user-list">
      <li
        v-for="member in items"
        :key="member.id"
        :class="{ 'pl-chat-user-list__item--not-change': itSelf(member.id) }"
        class="pl-chat-user-list__item"
      >
        <pl-chat-avatar :entity="member" />
        <div class="pl-chat-user-list__item-body">
          <div class="pl-chat-user-list__title">
            <div class="pl-chat-user-list__name">
              {{ getNumberPhoneMember(member) }}
            </div>
          </div>

          <div class="pl-chat-user-list__button-action">
            <v-btn icon @click="$emit('add-member', member)">
              <v-icon color="rgba(0,0,0,0.6)">chevron_right</v-icon>
            </v-btn>
          </div>
        </div>
      </li>
    </ul>
  </article>
</template>

<script>
import PlChatAvatar from './PlChatAvatar'
import debounce from './debounce'
import { getNameWithLastFourSymbolPhoneNumber } from '@/helpers/nameWithLastFourSymbolPhoneNumber'

export default {
  name: 'PlChatUserList',
  components: {
    PlChatAvatar,
  },
  data() {
    return {
      filterValue: '',
      searchStr: '',
      loading: false,
    }
  },
  props: {
    members: {
      type: Array,
      default: () => [],
    },
    settings: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
  },
  computed: {
    items() {
      return this.members
    },
    emptyMessage() {
      if (this.type === 'users') {
        return 'Поиск не дал результатов... :('
      } else if (this.type === 'users') {
        return 'В чате пока нет участников'
      }
    },
  },
  methods: {
    itSelf(id) {
      return id === this.$store.state.plChat.profile.id
    },
    async searchUser() {
      this.loading = true

      if (this.searchStr) {
        await this.$store.dispatch('searchUsers', {
          searchStr: this.searchStr,
        })
      } else {
        await this.$store.dispatch('getUsers', {
          reloading: false,
          limit: null,
          offset: null,
        })
      }

      this.loading = false
    },
    clearSearchString() {
      this.searchStr = ''
      this.searchUser()
    },
    getNumberPhoneMember(member) {
      return getNameWithLastFourSymbolPhoneNumber(member)
    },
    handlerEventInput(value) {
      if (value && value.length > 2) {
        this.handlerEventInputDebounce()
      }
    },
    handlerEventInputDebounce: debounce(
      function () {
        this.searchUser()
      },
      600,
      false,
    ),
  },
}
</script>

<style scoped lang="scss">
.pl-chat-user-list {
  list-style-type: none;
  padding: 0 1rem 1rem;
  overflow-y: scroll;
  max-height: calc(85vh - 13.5rem - 96px);

  &__users-list-subtitle {
    padding: 1rem 1rem 0;
    text-align: center;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 0 0.5rem;
    margin-bottom: 0.2rem;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.12);
  }

  &__item--not-change {
    background-color: rgba(0, 0, 0, 0.12);
  }

  &__item-body {
    display: flex;
    justify-content: space-between;
    flex: 1 1 auto;
  }

  &__name {
    margin: 1rem;
    max-height: 3rem;
    overflow: hidden;
  }

  &__button-action {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &__filter {
    padding: 4px 1rem 0.5rem;
    margin: 0;
  }

  &__search {
    display: flex;
    align-items: flex-end;
    padding: 0 1.6rem 0 1rem;
  }
}
</style>
